export default "__VITE_ASSET__DYHldOBp__"